import { render, staticRenderFns } from "./choose-service.vue?vue&type=template&id=773672a7&scoped=true&"
import script from "./choose-service.vue?vue&type=script&lang=js&"
export * from "./choose-service.vue?vue&type=script&lang=js&"
import style0 from "./choose-service.vue?vue&type=style&index=0&id=773672a7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773672a7",
  null
  
)

export default component.exports